
/**
 * Obtém a data de vencimento de um certificado PEM.
 * @param {string} pemString - O certificado no formato -----BEGIN CERTIFICATE-----
 * @returns {Date} - Objeto Date com a data de expiração (validTo)
 */
module.exports.obterVencimentoCertificado = (pemString) => {
    let crypto = require('crypto');
    try {
        // O método parseCert extrai as informações do certificado PEM
        const cert = new crypto.X509Certificate(pemString);

        // A propriedade validTo contém a data de expiração como string
        return new Date(cert.validTo);
    } catch (error) {
        throw new Error("Erro ao processar o certificado: " + error.message);
    }
}

module.exports.obterVencimentoCertificado2 = (pemString) =>{
    try {
        let rs = require('jsrsasign');
        const cert = new rs.X509();
        cert.readCertPEM(pemString);

        // O formato retornado é YYMMDDHHMMSSZ
        const dataString = cert.getNotAfter();

        // Converte o formato esquisito para um objeto Date legível
        const ano = "20" + dataString.substring(0, 2);
        const mes = dataString.substring(2, 4) - 1; // Meses em JS começam em 0
        const dia = dataString.substring(4, 6);
        const hora = dataString.substring(6, 8);
        const min = dataString.substring(8, 10);

        return new Date(ano, mes, dia, hora, min);
    } catch (error) {
        throw new Error("Erro ao ler PEM com jsrsasign: " + error.message);
    }
}



// WEBPACK FOOTER //
// ./src/util/util.js